export default function TypeBadge({ type }) {
  const key = type?.toLowerCase();

  const styleMap = {
    event: "bg-blue-100 text-blue-700",
    tournament: "bg-purple-100 text-purple-700",

    // possible future types
    camp: "bg-teal-100 text-teal-700",
    talk: "bg-orange-100 text-orange-700",
    seminar: "bg-yellow-100 text-yellow-700",
    workshop: "bg-pink-100 text-pink-700",
    sparring: "bg-indigo-100 text-indigo-700",
    fitness: "bg-emerald-100 text-emerald-700",
    friendlyMatch: "bg-sky-100 text-sky-700",
  };

  const styles = styleMap[key] || "bg-gray-200 text-gray-600";

  return (
    <span className={`px-2 py-1 text-xs rounded-full ${styles}`}>
      {type}
    </span>
  );
}
